import { useInput } from "@redotech/react-util/form";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useContext } from "react";
import { verifyForm } from "../common";
import { ScanningContext } from "../scanning-context/context";

type ToteOrderSelectionModalProps = { isOpen: boolean; onClose: () => void };

export const ToteOrderSelectionModal = memo(function ToteOrderSelectionModal({
  isOpen,
  onClose,
}: ToteOrderSelectionModalProps) {
  const scanning = useContext(ScanningContext);
  const { handleScan, pending } = scanning;

  const form = useInput(verifyForm, { barcode: "" });
  const { barcode } = form.inputs;

  return (
    <RedoModal
      isOpen={isOpen}
      onModalCloseRequested={() => {
        barcode.setValue("");
        onClose();
      }}
      title="Tote Order Selection"
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleScan(barcode);
        }}
        style={{ display: "flex" }}
      >
        <Flex align="center" gap="lg">
          <Flex gap="xl">
            <Flex
              basis={0}
              data-testid="scan-page-lookup-fulfillment-id-input"
              flex={1}
            >
              <RedoTextInput
                autoFocus
                placeholder="Enter item barcode"
                ref={(el) => el?.focus()}
                setValue={barcode.setValue}
                size="sm"
                value={barcode.value}
              />
            </Flex>
          </Flex>
          <Flex>
            <RedoButton
              disabled={!!form.allErrors.length}
              hierarchy="primary"
              pending={pending}
              text="Find shipment"
              theme="success"
              type="submit"
            />
          </Flex>
        </Flex>
      </form>
    </RedoModal>
  );
});
